<template>
  <div class="ws-card" :class="{ 'shadow-bold': shadowBold }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    shadowBold: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>
</style>
